import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { Chip, PageHead, Person, Table, Tabs, Tiles, fmt, when } from "./kit";

const cell = { width: "100%", padding: "5px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

const tierChip = (level) =>
  ({
    1: <Chip kind="wait">Gümüş</Chip>,
    2: <Chip>Altın</Chip>,
    3: <Chip kind="info">Elmas</Chip>,
  }[level] || level);

/// Koruma: kullanici bir yayincinin koruyucusu olur. Seviyeler ve yayinci payi buradan ayarlanir.
const Guardian = () => {
  const [tab, setTab] = useState("ayar");
  const [cfg, setCfg] = useState(null);
  const [rows, setRows] = useState({ rows: [], total: 0, count: 0 });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  const flash = (m) => {
    setMsg(m);
    setTimeout(() => setMsg(""), 3500);
  };

  const load = useCallback(async () => {
    const r = await api.config();
    if (r?.status) {
      setCfg({
        guardianEnabled: r.config.guardianEnabled !== false,
        guardianHostShare: Number(r.config.guardianHostShare) || 0,
        guardianTiers: r.config.guardianTiers || [],
      });
    }
  }, []);

  const loadRows = useCallback(async () => {
    setLoading(true);
    const r = await api.guardians();
    if (r?.status) setRows(r);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    if (tab === "liste") loadRows();
  }, [tab, loadRows]);

  const save = async (next = cfg) => {
    setSaving(true);
    const r = await api.saveConfig(next);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    flash("Kaydedildi");
    load();
  };

  const setTier = (i, k, v) => {
    const tiers = cfg.guardianTiers.map((t, j) => (i === j ? { ...t, [k]: v } : t));
    setCfg({ ...cfg, guardianTiers: tiers });
  };

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  return (
    <>
      <PageHead
        title="Koruma"
        sub="Kullanıcı coin ödeyip bir yayıncının koruyucusu olur. Süre dolunca koruma kendiliğinden düşer."
        right={msg ? <Chip>{msg}</Chip> : null}
      />

      <Tiles
        items={[
          { label: "Durum", value: cfg.guardianEnabled ? "Açık" : "Kapalı" },
          { label: "Yayıncı payı", value: `%${cfg.guardianHostShare}` },
          { label: "Aktif koruma", value: fmt(rows.count) },
          { label: "Toplam harcanan", value: `${fmt(rows.total)} coin` },
        ]}
      />

      <Tabs
        value={tab}
        onChange={setTab}
        tabs={[
          ["ayar", "Ayarlar"],
          ["liste", "Aktif korumalar"],
        ]}
      />

      {tab === "ayar" && (
        <>
          <div className="card" style={{ marginBottom: 16 }}>
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <div style={{ fontWeight: 600 }}>Koruma açık</div>
                <div style={small}>Kapatırsan uygulamada koruma satın alınamaz, mevcut korumalar süresince kalır.</div>
              </div>
              <button
                type="button"
                className={`btn btn-sm ${cfg.guardianEnabled ? "btn-success" : "btn-outline-secondary"}`}
                style={{ minWidth: 88 }}
                onClick={() => save({ ...cfg, guardianEnabled: !cfg.guardianEnabled })}
              >
                {cfg.guardianEnabled ? "Açık" : "Kapalı"}
              </button>
            </div>
          </div>

          <div className="card" style={{ marginBottom: 16 }}>
            <div className="card-body">
              <h5 style={{ margin: 0 }}>Yayıncı payı</h5>
              <div style={{ ...small, marginBottom: 12 }}>
                Ödenen coinin yüzde kaçı yayıncıya yazılır. Kalanı sistemde kalır.
              </div>
              <div style={{ maxWidth: 200 }}>
                <input
                  type="number"
                  className="form-control"
                  value={cfg.guardianHostShare}
                  onChange={(e) => setCfg({ ...cfg, guardianHostShare: Number(e.target.value) })}
                />
              </div>
              <button className="btn btn-primary btn-sm" style={{ marginTop: 12 }} disabled={saving} onClick={() => save()}>
                Kaydet
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h5 style={{ margin: 0 }}>Seviyeler</h5>
              <div style={{ ...small, marginBottom: 12 }}>
                Fiyat coin cinsinden. Görsel alanı boş bırakılırsa uygulamada çizilen kalkan kullanılır.
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Seviye</th>
                      <th>Ad</th>
                      <th>Fiyat (coin)</th>
                      <th>Gün</th>
                      <th>Görsel (URL)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cfg.guardianTiers.map((t, i) => (
                      <tr key={t.key}>
                        <td>{tierChip(t.level)}</td>
                        <td>
                          <input style={cell} value={t.name || ""} onChange={(e) => setTier(i, "name", e.target.value)} />
                        </td>
                        <td>
                          <input
                            style={cell}
                            type="number"
                            value={t.price || 0}
                            onChange={(e) => setTier(i, "price", Number(e.target.value))}
                          />
                        </td>
                        <td>
                          <input
                            style={{ ...cell, width: 80 }}
                            type="number"
                            value={t.days || 30}
                            onChange={(e) => setTier(i, "days", Number(e.target.value))}
                          />
                        </td>
                        <td>
                          <input style={cell} value={t.image || ""} onChange={(e) => setTier(i, "image", e.target.value)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button className="btn btn-primary btn-sm" disabled={saving} onClick={() => save()}>
                Kaydet
              </button>
            </div>
          </div>
        </>
      )}

      {tab === "liste" && (
        <Table
          head={["Yayıncı", "Koruyucu", "Seviye", "Harcanan", "Bitiş"]}
          loading={loading}
          empty="Aktif koruma yok."
          rows={rows.rows.map((r, i) => (
            <tr key={i}>
              <td>
                <Person image={r.hostImage} name={r.hostName} />
              </td>
              <td>
                <Person image={r.userImage} name={r.userName} />
              </td>
              <td>{tierChip(r.level)}</td>
              <td>{fmt(r.totalSpent)}</td>
              <td>{when(r.expiresAt)}</td>
            </tr>
          ))}
        />
      )}
    </>
  );
};

export default Guardian;
